// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.raffle-container {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    padding: 20px;
    width: 100%;
    margin: 0;
    color: #fff;
    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);
    border: 1px solid rgba(255, 119, 0, 0.2);
    backdrop-filter: blur(5px);
    box-sizing: border-box;
}

.home-challenges-section .raffle-container {
    padding: 15px;
    max-width: 100%;
}

.raffle-container h3 {
    color: #ff7700;
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 20px;
}

.raffle-container h4 {
    color: #ff9d4d;
    margin: 15px 0;
    font-size: 1.25rem;
}

.raffle-container h5 {
    font-size: 1.1rem;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #ff9d4d;
}

.challenge-management {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.challenge-input {
    display: flex;
    gap: 10px;
}

.challenge-input input {
    flex: 1 1;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.15);
    color: white;
    font-size: 1rem;
}

.challenge-input input::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.challenge-input button,
.start-raffle-btn,
.end-raffle-btn,
.toggle-challenges-btn {
    background-color: #ff7700;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 15px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
}

.challenge-input button:hover,
.start-raffle-btn:hover,
.end-raffle-btn:hover,
.toggle-challenges-btn:hover {
    background-color: #ff9d4d;
    transform: translateY(-2px);
}

.start-raffle-btn,
.end-raffle-btn {
    width: 100%;
    margin-top: 20px;
    padding: 12px;
    font-size: 1.1rem;
}

.end-raffle-btn {
    background-color: #e74c3c;
}

.end-raffle-btn:hover {
    background-color: #c0392b;
}

.challenges-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.toggle-challenges-btn {
    padding: 4px 10px;
    font-size: 0.8rem;
    background-color: rgba(255, 119, 0, 0.5);
}

.challenges-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.3);
    padding: 10px;
}

.home-challenges-section .challenges-list ul {
    max-height: 150px;
}

.challenges-list ul:not(.show-all) {
    max-height: 150px;
}

.challenges-list li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    margin-bottom: 5px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    color: #fff;
    transition: background-color 0.3s ease;
}

.challenges-list li.hidden {
    display: none;
}

.challenges-list li.more-indicator {
    background: none;
    color: rgba(255, 255, 255, 0.7);
    font-style: italic;
    text-align: center;
    padding: 5px;
}

.challenges-list li:hover {
    background: rgba(255, 255, 255, 0.15);
}

.challenges-list li.more-indicator:hover {
    background: none;
}

.remove-btn {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 1.2rem;
    cursor: pointer;
    transition: color 0.3s ease;
}

.remove-btn:hover {
    color: #ff4d4d;
}

button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.65;
}

.error-message {
    color: #ffcccc;
    text-align: center;
    padding: 10px;
    background: rgba(255, 0, 0, 0.2);
    border-radius: 5px;
    margin: 10px 0;
}

.members-info {
    margin-top: 10px;
}

.note {
    color: rgba(255, 255, 255, 0.8);
    font-style: italic;
    font-size: 0.9rem;
    margin-top: 5px;
}

/* Active raffle styles */
.raffle-status {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    background: rgba(52, 152, 219, 0.2);
    padding: 10px;
    border-radius: 4px;
    color: #3498db;
    font-weight: 600;
}

.status-indicator {
    width: 12px;
    height: 12px;
    background-color: #3498db;
    border-radius: 50%;
    display: inline-block;
    animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.raffle-results {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 10px;
}

.home-challenges-section .raffle-results {
    max-height: 200px;
}

.result-card {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-left: 3px solid #ff7700;
}

.pair {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.member-name {
    background: rgba(255, 119, 0, 0.2);
    color: #fff;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 0.9rem;
}

.challenge {
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.5;
}

/* User view styles */
.raffle-user-view {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
    color: #fff;
    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);
    border: 1px solid rgba(255, 119, 0, 0.2);
    backdrop-filter: blur(5px);
}

.raffle-user-view h3 {
    color: #ff7700;
    margin-bottom: 20px;
    text-align: center;
    font-size: 1.5rem;
}

.error-message {
    color: #ffcccc;
    text-align: center;
    margin-bottom: 20px;
    padding: 10px;
    background: rgba(255, 0, 0, 0.2);
    border-radius: 4px;
}

.challenges-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.challenge-card {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease;
    border: 1px solid rgba(255, 119, 0, 0.2);
}

.challenge-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 119, 0, 0.3);
}

.challenge-card.completed {
    background: rgba(40, 167, 69, 0.1);
    border: 1px solid rgba(40, 167, 69, 0.3);
}

.challenge-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.challenge-header h4 {
    margin: 0;
    color: #ff9d4d;
    font-size: 1.2rem;
}

.difficulty-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.8em;
    font-weight: 500;
}

.difficulty-1 {
    background-color: rgba(25, 118, 210, 0.2);
    color: #64b5f6;
}

.difficulty-2 {
    background-color: rgba(245, 124, 0, 0.2);
    color: #ffb74d;
}

.difficulty-3 {
    background-color: rgba(194, 24, 91, 0.2);
    color: #f48fb1;
}

.challenge-text {
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 15px;
    line-height: 1.5;
}

.partner-info {
    font-size: 0.9em;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 15px;
}

.partner-info span {
    font-weight: 500;
    color: #ff9d4d;
}

.challenge-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.challenge-date {
    font-size: 0.8em;
    color: rgba(255, 255, 255, 0.6);
}

.complete-button {
    background-color: #ff7700;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
    transition: all 0.2s ease;
}

.complete-button:hover {
    background-color: #ff9d4d;
    transform: translateY(-1px);
}

.complete-button:disabled {
    background-color: rgba(108, 117, 125, 0.5);
    cursor: not-allowed;
}

.completed-badge {
    background-color: rgba(40, 167, 69, 0.2);
    color: #4caf50;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8em;
    border: 1px solid rgba(40, 167, 69, 0.3);
}

.waiting-message {
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    padding: 20px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    margin-top: 20px;
    font-style: italic;
}

/* Responsive styles */
@media (max-width: 768px) {
    .raffle-user-view {
        width: 90%;
        padding: 15px;
    }
}

@keyframes caseOpening {
    0% {
        transform: translateY(100vh) rotateX(90deg);
        opacity: 0;
    }
    20% {
        transform: translateY(50vh) rotateX(45deg);
        opacity: 0.5;
    }
    40% {
        transform: translateY(0) rotateX(0deg);
        opacity: 1;
    }
    60% {
        transform: translateY(-20px) rotateX(-10deg);
    }
    80% {
        transform: translateY(0) rotateX(5deg);
    }
    100% {
        transform: translateY(0) rotateX(0deg);
    }
}

@keyframes glowPulse {
    0% {
        box-shadow: 0 0 5px rgba(255, 119, 0, 0.5);
    }
    50% {
        box-shadow: 0 0 20px rgba(255, 119, 0, 0.8);
    }
    100% {
        box-shadow: 0 0 5px rgba(255, 119, 0, 0.5);
    }
}

.challenge-card.new-challenge {
    animation: popOut 0.5s ease-out forwards, glowOnce 3s forwards;
    transform-origin: center;
    box-shadow: 0 0 20px rgba(255, 119, 0, 0.8);
    z-index: 10;
    position: relative;
}

@keyframes popOut {
    0% {
        transform: scale(0.8);
    }
    50% {
        transform: scale(1.1);
    }
    75% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes glowOnce {
    0% {
        box-shadow: 0 0 10px rgba(255, 119, 0, 0.8);
    }
    30% {
        box-shadow: 0 0 25px rgba(255, 119, 0, 1), 0 0 35px rgba(255, 235, 59, 0.8);
    }
    70% {
        box-shadow: 0 0 25px rgba(255, 119, 0, 1), 0 0 35px rgba(255, 235, 59, 0.8);
    }
    100% {
        box-shadow: 0 0 10px rgba(255, 119, 0, 0.3);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Raffle.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,SAAS;IACT,WAAW;IACX,6CAA6C;IAC7C,wCAAwC;IACxC,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;IAII,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mCAAmC;IACnC,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,6CAA6C;IAC7C,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2CAA2C;QAC3C,UAAU;IACd;IACA;QACI,0CAA0C;QAC1C,YAAY;IAChB;IACA;QACI,sCAAsC;QACtC,UAAU;IACd;IACA;QACI,4CAA4C;IAChD;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI,8DAA8D;IAC9D,wBAAwB;IACxB,2CAA2C;IAC3C,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,2EAA2E;IAC/E;IACA;QACI,2EAA2E;IAC/E;IACA;QACI,2CAA2C;IAC/C;AACJ","sourcesContent":[".raffle-container {\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    padding: 20px;\n    width: 100%;\n    margin: 0;\n    color: #fff;\n    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);\n    border: 1px solid rgba(255, 119, 0, 0.2);\n    backdrop-filter: blur(5px);\n    box-sizing: border-box;\n}\n\n.home-challenges-section .raffle-container {\n    padding: 15px;\n    max-width: 100%;\n}\n\n.raffle-container h3 {\n    color: #ff7700;\n    text-align: center;\n    font-size: 1.5rem;\n    margin-bottom: 20px;\n}\n\n.raffle-container h4 {\n    color: #ff9d4d;\n    margin: 15px 0;\n    font-size: 1.25rem;\n}\n\n.raffle-container h5 {\n    font-size: 1.1rem;\n    margin-top: 15px;\n    margin-bottom: 10px;\n    color: #ff9d4d;\n}\n\n.challenge-management {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.challenge-input {\n    display: flex;\n    gap: 10px;\n}\n\n.challenge-input input {\n    flex: 1;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    background: rgba(255, 255, 255, 0.15);\n    color: white;\n    font-size: 1rem;\n}\n\n.challenge-input input::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.challenge-input button,\n.start-raffle-btn,\n.end-raffle-btn,\n.toggle-challenges-btn {\n    background-color: #ff7700;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 15px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: all 0.3s ease;\n}\n\n.challenge-input button:hover,\n.start-raffle-btn:hover,\n.end-raffle-btn:hover,\n.toggle-challenges-btn:hover {\n    background-color: #ff9d4d;\n    transform: translateY(-2px);\n}\n\n.start-raffle-btn,\n.end-raffle-btn {\n    width: 100%;\n    margin-top: 20px;\n    padding: 12px;\n    font-size: 1.1rem;\n}\n\n.end-raffle-btn {\n    background-color: #e74c3c;\n}\n\n.end-raffle-btn:hover {\n    background-color: #c0392b;\n}\n\n.challenges-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.toggle-challenges-btn {\n    padding: 4px 10px;\n    font-size: 0.8rem;\n    background-color: rgba(255, 119, 0, 0.5);\n}\n\n.challenges-list ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    max-height: 200px;\n    overflow-y: auto;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.3);\n    padding: 10px;\n}\n\n.home-challenges-section .challenges-list ul {\n    max-height: 150px;\n}\n\n.challenges-list ul:not(.show-all) {\n    max-height: 150px;\n}\n\n.challenges-list li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 10px;\n    margin-bottom: 5px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    color: #fff;\n    transition: background-color 0.3s ease;\n}\n\n.challenges-list li.hidden {\n    display: none;\n}\n\n.challenges-list li.more-indicator {\n    background: none;\n    color: rgba(255, 255, 255, 0.7);\n    font-style: italic;\n    text-align: center;\n    padding: 5px;\n}\n\n.challenges-list li:hover {\n    background: rgba(255, 255, 255, 0.15);\n}\n\n.challenges-list li.more-indicator:hover {\n    background: none;\n}\n\n.remove-btn {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 1.2rem;\n    cursor: pointer;\n    transition: color 0.3s ease;\n}\n\n.remove-btn:hover {\n    color: #ff4d4d;\n}\n\nbutton:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n    opacity: 0.65;\n}\n\n.error-message {\n    color: #ffcccc;\n    text-align: center;\n    padding: 10px;\n    background: rgba(255, 0, 0, 0.2);\n    border-radius: 5px;\n    margin: 10px 0;\n}\n\n.members-info {\n    margin-top: 10px;\n}\n\n.note {\n    color: rgba(255, 255, 255, 0.8);\n    font-style: italic;\n    font-size: 0.9rem;\n    margin-top: 5px;\n}\n\n/* Active raffle styles */\n.raffle-status {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n    background: rgba(52, 152, 219, 0.2);\n    padding: 10px;\n    border-radius: 4px;\n    color: #3498db;\n    font-weight: 600;\n}\n\n.status-indicator {\n    width: 12px;\n    height: 12px;\n    background-color: #3498db;\n    border-radius: 50%;\n    display: inline-block;\n    animation: pulse 1.5s infinite ease-in-out;\n}\n\n@keyframes pulse {\n    0% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.5;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.raffle-results {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 15px;\n    max-height: 300px;\n    overflow-y: auto;\n    padding-right: 10px;\n}\n\n.home-challenges-section .raffle-results {\n    max-height: 200px;\n}\n\n.result-card {\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    padding: 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-left: 3px solid #ff7700;\n}\n\n.pair {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.member-name {\n    background: rgba(255, 119, 0, 0.2);\n    color: #fff;\n    padding: 5px 10px;\n    border-radius: 20px;\n    font-size: 0.9rem;\n}\n\n.challenge {\n    color: rgba(255, 255, 255, 0.9);\n    line-height: 1.5;\n}\n\n/* User view styles */\n.raffle-user-view {\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    padding: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n    color: #fff;\n    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);\n    border: 1px solid rgba(255, 119, 0, 0.2);\n    backdrop-filter: blur(5px);\n}\n\n.raffle-user-view h3 {\n    color: #ff7700;\n    margin-bottom: 20px;\n    text-align: center;\n    font-size: 1.5rem;\n}\n\n.error-message {\n    color: #ffcccc;\n    text-align: center;\n    margin-bottom: 20px;\n    padding: 10px;\n    background: rgba(255, 0, 0, 0.2);\n    border-radius: 4px;\n}\n\n.challenges-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.challenge-card {\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    transition: transform 0.2s ease;\n    border: 1px solid rgba(255, 119, 0, 0.2);\n}\n\n.challenge-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(255, 119, 0, 0.3);\n}\n\n.challenge-card.completed {\n    background: rgba(40, 167, 69, 0.1);\n    border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.challenge-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.challenge-header h4 {\n    margin: 0;\n    color: #ff9d4d;\n    font-size: 1.2rem;\n}\n\n.difficulty-badge {\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 0.8em;\n    font-weight: 500;\n}\n\n.difficulty-1 {\n    background-color: rgba(25, 118, 210, 0.2);\n    color: #64b5f6;\n}\n\n.difficulty-2 {\n    background-color: rgba(245, 124, 0, 0.2);\n    color: #ffb74d;\n}\n\n.difficulty-3 {\n    background-color: rgba(194, 24, 91, 0.2);\n    color: #f48fb1;\n}\n\n.challenge-text {\n    color: rgba(255, 255, 255, 0.9);\n    margin-bottom: 15px;\n    line-height: 1.5;\n}\n\n.partner-info {\n    font-size: 0.9em;\n    color: rgba(255, 255, 255, 0.8);\n    margin-bottom: 15px;\n}\n\n.partner-info span {\n    font-weight: 500;\n    color: #ff9d4d;\n}\n\n.challenge-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.challenge-date {\n    font-size: 0.8em;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.complete-button {\n    background-color: #ff7700;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9em;\n    transition: all 0.2s ease;\n}\n\n.complete-button:hover {\n    background-color: #ff9d4d;\n    transform: translateY(-1px);\n}\n\n.complete-button:disabled {\n    background-color: rgba(108, 117, 125, 0.5);\n    cursor: not-allowed;\n}\n\n.completed-badge {\n    background-color: rgba(40, 167, 69, 0.2);\n    color: #4caf50;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.8em;\n    border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.waiting-message {\n    text-align: center;\n    color: rgba(255, 255, 255, 0.8);\n    padding: 20px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 8px;\n    margin-top: 20px;\n    font-style: italic;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n    .raffle-user-view {\n        width: 90%;\n        padding: 15px;\n    }\n}\n\n@keyframes caseOpening {\n    0% {\n        transform: translateY(100vh) rotateX(90deg);\n        opacity: 0;\n    }\n    20% {\n        transform: translateY(50vh) rotateX(45deg);\n        opacity: 0.5;\n    }\n    40% {\n        transform: translateY(0) rotateX(0deg);\n        opacity: 1;\n    }\n    60% {\n        transform: translateY(-20px) rotateX(-10deg);\n    }\n    80% {\n        transform: translateY(0) rotateX(5deg);\n    }\n    100% {\n        transform: translateY(0) rotateX(0deg);\n    }\n}\n\n@keyframes glowPulse {\n    0% {\n        box-shadow: 0 0 5px rgba(255, 119, 0, 0.5);\n    }\n    50% {\n        box-shadow: 0 0 20px rgba(255, 119, 0, 0.8);\n    }\n    100% {\n        box-shadow: 0 0 5px rgba(255, 119, 0, 0.5);\n    }\n}\n\n.challenge-card.new-challenge {\n    animation: popOut 0.5s ease-out forwards, glowOnce 3s forwards;\n    transform-origin: center;\n    box-shadow: 0 0 20px rgba(255, 119, 0, 0.8);\n    z-index: 10;\n    position: relative;\n}\n\n@keyframes popOut {\n    0% {\n        transform: scale(0.8);\n    }\n    50% {\n        transform: scale(1.1);\n    }\n    75% {\n        transform: scale(1.05);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes glowOnce {\n    0% {\n        box-shadow: 0 0 10px rgba(255, 119, 0, 0.8);\n    }\n    30% {\n        box-shadow: 0 0 25px rgba(255, 119, 0, 1), 0 0 35px rgba(255, 235, 59, 0.8);\n    }\n    70% {\n        box-shadow: 0 0 25px rgba(255, 119, 0, 1), 0 0 35px rgba(255, 235, 59, 0.8);\n    }\n    100% {\n        box-shadow: 0 0 10px rgba(255, 119, 0, 0.3);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
